import { Box, Paper, Button, Typography } from "@mui/material";
import GppBadIcon from '@mui/icons-material/GppBad';

export default function UnauthorizedModal({handleLogout}) {
  return (
    <Box
      sx={{
        height: "100vh",
        bgcolor: "#f9fafb",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 5,
          width: 360,
          textAlign: "center",
          borderRadius: 3,
        }}
      >
        {/* 아이콘 영역 */}
        <Box mb={3}>
          <GppBadIcon sx={{ fontSize: 48, color: "error.main" }} />
        </Box>

        {/* 안내 문구 */}
        <Typography variant="h11" fontWeight="bold" gutterBottom>
          권한이 없는 사용자 입니다.
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={4}>
          관리자에게 문의 하십시오.
        </Typography>

        {/* 버튼 */}
        <Button
            variant="contained"
            fullWidth
            onClick={handleLogout}
            sx={{ textTransform: "none", fontWeight: 600 }}
        >
            확인
        </Button>
      </Paper>
    </Box>
  );
}